/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInitiativeDependencyRequest
 */
export interface CreateInitiativeDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeDependencyRequest
     */
    predecessorInitiativeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeDependencyRequest
     */
    successorInitiativeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeDependencyRequest
     */
    dependencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateInitiativeDependencyRequest
     */
    lagDays?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateInitiativeDependencyRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CreateInitiativeDependencyRequest interface.
 */
export function instanceOfCreateInitiativeDependencyRequest(value: object): value is CreateInitiativeDependencyRequest {
    if (!('predecessorInitiativeId' in value) || value['predecessorInitiativeId'] === undefined) return false;
    if (!('successorInitiativeId' in value) || value['successorInitiativeId'] === undefined) return false;
    return true;
}

export function CreateInitiativeDependencyRequestFromJSON(json: any): CreateInitiativeDependencyRequest {
    return CreateInitiativeDependencyRequestFromJSONTyped(json, false);
}

export function CreateInitiativeDependencyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInitiativeDependencyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'predecessorInitiativeId': json['predecessorInitiativeId'],
        'successorInitiativeId': json['successorInitiativeId'],
        'dependencyType': json['dependencyType'] == null ? undefined : json['dependencyType'],
        'lagDays': json['lagDays'] == null ? undefined : json['lagDays'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CreateInitiativeDependencyRequestToJSON(json: any): CreateInitiativeDependencyRequest {
    return CreateInitiativeDependencyRequestToJSONTyped(json, false);
}

export function CreateInitiativeDependencyRequestToJSONTyped(value?: CreateInitiativeDependencyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'predecessorInitiativeId': value['predecessorInitiativeId'],
        'successorInitiativeId': value['successorInitiativeId'],
        'dependencyType': value['dependencyType'],
        'lagDays': value['lagDays'],
        'effectTenantId': value['effectTenantId'],
    };
}

